import { render, staticRenderFns } from "./ResponsibleAgent.vue?vue&type=template&id=459228c6&"
import script from "./ResponsibleAgent.vue?vue&type=script&lang=js&"
export * from "./ResponsibleAgent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports